<template>
    <div class="flex flex-col dark:text-white">
        <h3 class="my-2 text-base font-semibold text-gray-700 dark:text-gray-200">
            Usuário
        </h3>
        <div
            class="border border-black/5 dark:border-white/10 min-w-0 w-full rounded-xl overflow-hidden bg-white dark:bg-white/[0.02] mb-4 shadow-xs p-5"
        >
            <div class="grid grid-cols-3 gap-3">
                <div class="flex flex-col">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >CLIENTE</span
                    >
                    <span
                        class="text-gray-800 dark:text-gray-200"
                        v-if="order"
                        >{{ order.customer.name }}</span
                    >
                </div>
                <div class="flex flex-col">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >EMAIL</span
                    >
                    <span
                        class="text-gray-800 dark:text-gray-200"
                        v-if="order"
                        >{{ order.customer.email }}</span
                    >
                </div>
                <div
                    class="flex flex-col"
                    v-if="order.customer && order.customer.cpf"
                >
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >CPF</span
                    >
                    <span class="text-gray-800 dark:text-gray-200">{{
                        order.customer.cpf
                    }}</span>
                </div>
                <div
                    class="flex flex-col"
                    v-if="order.customer && order.customer.cnpj"
                >
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >CNPJ</span
                    >
                    <span class="text-gray-800 dark:text-gray-200">{{
                        order.customer.cnpj
                    }}</span>
                </div>
                <div
                    class="flex flex-col"
                    v-if="order.customer && order.customer.phones"
                >
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >TELEFONE</span
                    >
                    <span
                        class="text-gray-800 dark:text-gray-200"
                        v-for="phone in order.customer.phones"
                    >
                        {{ phone.ddi || "" }} ({{ phone.ddd }})
                        {{ formatPhone(phone.number) }}</span
                    >
                </div>
            </div>
        </div>
        <h3 v-if="order.address" class="my-2 text-base font-semibold text-gray-700 dark:text-gray-200">
            Endereço
        </h3>
        <div
            v-if="order.address"
            class="border border-black/5 dark:border-white/10 min-w-0 w-full rounded-xl overflow-hidden bg-white dark:bg-white/[0.02] mb-4 shadow-xs p-5"
        >
            <div class="grid grid-cols-3 gap-3">
                <div class="flex flex-col">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Rua</span
                    >
                    <span class="text-gray-800 dark:text-gray-200">{{
                        order.address.street
                    }}</span>
                </div>
                <div class="flex flex-col">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Número</span
                    >
                    <span class="text-gray-800 dark:text-gray-200">{{
                        order.address.street_number
                    }}</span>
                </div>
                <div class="flex flex-col" v-if="order.address.complement">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Complemento</span
                    >
                    <span class="text-gray-800 dark:text-gray-200">{{
                        order.address.complement
                    }}</span>
                </div>
                <div class="flex flex-col" v-if="order.address.reference">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Referencia</span
                    >
                    <span class="text-gray-800 dark:text-gray-200">{{
                        order.address.reference
                    }}</span>
                </div>
                <div class="flex flex-col">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Bairro</span
                    >
                    <span class="text-gray-800 dark:text-gray-200">{{
                        order.address.neighborhood
                    }}</span>
                </div>
                <div class="flex flex-col">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Cidade</span
                    >
                    <span class="text-gray-800 dark:text-gray-200">{{
                        order.address.city
                    }}</span>
                </div>
                <div class="flex flex-col">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >Estado</span
                    >
                    <span class="text-gray-800 dark:text-gray-200">{{
                        order.address.state
                    }}</span>
                </div>
                <div class="flex flex-col">
                    <span
                        class="text-[11px] font-semibold uppercase tracking-wider text-gray-400 dark:text-gray-500"
                        >CEP</span
                    >
                    <span class="text-gray-800 dark:text-gray-200">{{
                        order.address.zip_code
                    }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HelperMixin from "../../mixins/HelperMixin.vue";

export default {
    props: ["order"],
    mixins: [HelperMixin],
    data() {
        return {
            loading: false,
            next_page_url: false,
            commissions: [],
            filters: {
                text: "",
                status: [],
                payment_method: [],
            },
        };
    },
    methods: {
        addressTitle(isDefault) {
            if (isDefault) {
                return "Endereço Principal";
            }
            return "Endereço Secundário";
        },
    },
};
</script>
